<template>
  <div class="main-body">
    <div class="main-panel" style="height: 800px">
      <div class="main-title-wrap">
        <a-button style="float: right; padding: 30px 50px" type="link" v-has="'MENU_ADD'"  @click="addMenu">
          添加
        </a-button>
      </div>
      <a-table
        style="width: 100%"
        :default-expand-all="false"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :data="table.data">
        <a-table-column
          prop="name"
          title="菜单名称"
          width="">
        </a-table-column>
        <a-table-column
          prop="type"
          title="分类"
          width="80"
        >
          <template slot-scope="text, record">
            <a-tag v-if="record.type==='BUTTON'" type="success">按钮</a-tag>
            <a-tag v-if="record.type==='MENU'" type="info">菜单</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          title="图标"
          width="80">
          <template v-slot="scope">
            <i :class="record.icon"/>
          </template>
        </a-table-column>
        <a-table-column
          title="编码"
          prop="code"
          width="">
        </a-table-column>
        <a-table-column
          prop="path"
          title="前端路径">
        </a-table-column>
        <a-table-column
          prop="interfaceApi"
          title="后端接口">
        </a-table-column>
        <a-table-column
          prop="requestMethod"
          width="100"
          title="请求方式">
        </a-table-column>
        <a-table-column
          prop="date"
          label="操作">
          <template slot-scope="text, record">
            <div class="table-operation-wrap">
              <a-button v-has="'MENU_EDIT'" type="link" @click="editMenu(record.id)">编辑
              </a-button>
              <a-button v-has="'MENU_DELETE'" type="link" @click="deleteMenu(record.id)">删除
              </a-button>
              <a-button v-has="'MENU_UP'" type="link" @click="upMenu(record.id)">上移
              </a-button>
              <a-button v-has="'MENU_DOWN'" type="link" @click="downMenu(record.id)">下移
              </a-button>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      @close="closeForm"
      v-model="form.visible">
      <menu-edit
        v-if="form.visible"
        :menu-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </menu-edit>
    </a-modal>
  </div>
</template>

<script>
import {
  _deleteMenu,
  _downMenu,
  _queryMenus,
  _upMenu,
} from '@/api/sysMenuApi';
import MenuEdit from './MenuEdit.vue';

function treeGenerator(x, data) {
  const children = data
    .filter(child => child.parentId === x.id)
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

async function getMenuList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascending' ? 'ASC' : 'DESC';
  }
  const result = await _queryMenus({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  const { menus } = result.data;
  this.table.data = menus
    .filter(x => !x.parentId)
    .map(x => treeGenerator(x, menus));
}

function addMenu() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editMenu(menuId) {
  this.form.data.id = menuId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getMenuList();
}

async function deleteMenu(menuId) {
  this.$confirm('是否删除?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    const result = await _deleteMenu(menuId);
    if (result.code === 1200) {
      this.$message({
        type: 'success',
        message: '删除成功!',
      });
      this.getMenuList();
    }
  });
}

async function upMenu(menuId) {
  this.$confirm('是否上移菜单?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    const result = await _upMenu(menuId);
    if (result.code === 1200) {
      this.$message({
        type: 'success',
        message: '上移成功!',
      });
      this.getMenuList();
    }
  });
}

async function downMenu(menuId) {
  this.$confirm('是否下移菜单?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    const result = await _downMenu(menuId);
    if (result.code === 1200) {
      this.$message({
        type: 'success',
        message: '下移成功!',
      });
      this.getMenuList();
    }
  });
}

export default {
  name: 'MenuList',
  components: { MenuEdit },
  data() {
    return {
      formInline: {
        user: '',
        region: '',
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'ascending',
        },
      },
    };
  },
  methods: {
    getMenuList,
    deleteMenu,
    editMenu,
    addMenu,
    closeForm,
    upMenu,
    downMenu,
  },
  created() {
    this.getMenuList();
  },
};
</script>

<style scoped>

</style>
